<ng-container *ngIf="session">
  <article>
    <div class="flex flex-col md:flex-row">
      <h3>
        <button
          class="text-left inline-block"
          (click)="handleButtonClick()"
          type="button"
        >
          <span
            class="text-red h4"
          >
            {{ session.title }}
          </span>
        </button>
      </h3>
      <!-- <ng-container *ngIf="!session.isServiceSession">
        <div class="order-first md:order-last mb-8 md:mb-0 md:ml-auto">
          <ul class="flex items-center">
            <ng-container *ngFor="let item of categoryItems;">
              <li class="py-4">
                <app-tag [text]="item.name"></app-tag>
              </li>
            </ng-container>
          </ul>
        </div>
      </ng-container> -->
    </div>
    <ng-container *ngIf="showDescription">
      <div class="pt-16">
        <p>
          {{ session.description }}
        </p>
      </div>
    </ng-container>
    <div>
      <div
        class="flex flex-col md:flex-row"
        [ngClass]="{ 'pt-16' : showPersona}"
      >
        <ng-container *ngIf="showPersona && speakers.length > 0">
          <div class="border-gray-light pr-16 mr-16 md:border-r">
            <ul>
              <ng-container *ngFor="let speaker of speakers;">
                <li class="py-4">
                  <app-persona-short [speaker]="speaker"></app-persona-short>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
        <div class=""
          [ngClass]="speakers.length > 0 ? 'md:pt-16' : '' "
        >
          <table>
            <thead>
              <tr>
                <ng-container *ngIf="showTime === true">
                  <th class="sr-only">
                    Time
                  </th>
                </ng-container>
                <ng-container *ngIf="showLocation === true">
                  <th class="sr-only">
                    Location
                  </th>
                </ng-container>
              </tr>
            </thead>
            <tbody>
              <!-- do we ever need to loop through multiple times and rooms? -->
              <tr>
                <ng-container *ngIf="showTime === true">
                  <td class="strong">
                    {{ session.startsAt| date:"hh:mm a" }} - {{ session.endsAt | date:"hh:mm a"  }}
                  </td>
                </ng-container>
                <ng-container *ngIf="showLocation === true">
                  <td
                    class="uppercase"
                    [ngClass]="{ 'pl-16': showTime === true }"
                  >
                    <ng-container *ngIf="room">
                      {{ room.name }}
                    </ng-container>
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </article>
</ng-container>
